import { useTranslation } from "react-i18next";
import { AuthShell } from "@/features/auth/AuthShell";
import { RegisterForm } from "@/features/auth/RegisterForm";

export default function Register() {
  const { t } = useTranslation();
  return (
    <AuthShell title={t("register.title")} subtitle={t("register.subtitle")}>
      <RegisterForm />
    </AuthShell>
  );
}
